import * as React from 'react';
import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State'; 
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { network, createCompany } from 'src/api';
import { IRequestParams } from 'kts-platform-frame/display/part/CompanySelection';
import { message, Modal } from 'antd';
import { companyInfo, tagmodule } from 'src/api'; 

class ModulesAction extends ActionBasic<ModulesState> {
    /** tab切换 */
    public onChangeTab = (pathkey) => {  
        this.modulesState.tabchange = pathkey; 
        this.setModulesState();   
    }
    /** 
     * 初始化翻页控件数据,网络平台
     */
    public initModulesStatePlatform = () => {
        this.modulesState.statePlatform.pagination = {
            total: 0,
            current: 1,
            defaultCurrent: 1,
            pageSize: 20, 
            onChange: this.pageListPlatform
        };
        this.setModulesState(this.modulesState);
    }
    /**
     * 网络管理，平台网络列表查询
     * @param pageNum 第几页 
     * @memberof ModulesAction
     */
    public pageListPlatform = async (pageNum = 1) => { 
        // 涉及到平台隐私问题，要求搜索条件无值时，不进行查询
        if (!this.modulesState.statePlatform.paramCondition.name && !this.modulesState.statePlatform.paramCondition.taxId) {
            this.modulesState.statePlatform.list = [];
            this.modulesState.statePlatform.pagination.total = 0;
            this.modulesState.statePlatform.pagination.current = 1; 
            this.setModulesState();
            return;
        }
        this.modulesState.statePlatform.hasMoreItems = true;
        let data = await network.platformNetworkList(this, { 
            ...this.modulesState.statePlatform.paramCondition, 
            pageNum: pageNum, 
            pageSize: 20, //  this.modulesState.statePlatform.pagination.pageSize 
        }); 
        if (!data.er) {  
            this.modulesState.statePlatform.list = data.res.items && data.res.items.map((item, index) => {
                return {
                    ...item,
                    index
                };
            });
            this.modulesState.statePlatform.pagination.total = data.res.pageMeta.total;
            this.modulesState.statePlatform.pagination.current = data.res.pageMeta.pageNum; 
            this.setModulesState(this.modulesState);
        }
    } 
    /** 滚动分页: 平台分页 */
    public pageListPlatformscroll = async () => { 
        if (this.modulesState.statePlatform.hasMoreItems) { 
            let pageNum = this.modulesState.statePlatform.pagination.current + 1;
            let data = await network.platformNetworkList(this, { 
                ...this.modulesState.statePlatform.paramCondition, 
                pageNum: pageNum, 
                pageSize: this.modulesState.statePlatform.pagination.pageSize 
            }); 
            if (!data.er) {   
                // 过滤重复的数据 
                if (!this.modulesState.statePlatform.list[(pageNum-1) * this.modulesState.statePlatform.pagination.pageSize]) {
                    this.modulesState.statePlatform.list = this.modulesState.statePlatform.list.concat(data.res.items && data.res.items.map((item, index) => {
                        return {
                            ...item,
                            index:(pageNum-1) * this.modulesState.statePlatform.pagination.pageSize + index
                        };
                    }));
                    // this.modulesState.statePlatform.hasMoreItems = data.res.pageMeta.total > this.modulesState.statePlatform.list.length ;
                    this.modulesState.statePlatform.pagination.total = data.res.pageMeta.total;
                    this.modulesState.statePlatform.pagination.current = data.res.pageMeta.pageNum; 
                    this.setModulesState(this.modulesState); 
                } 
            }
        }
    }
    /** 滚动分页： 网络管理，我的列表 */
    public pageListAdminMylistscroll = async () => { 
        // if (this.modulesState.stateMylist.hasMoreItems) { 
            let pageNum = this.modulesState.stateMylist.pagination.current + 1;
            let data = await network.myNetworkList(this, { 
                ...this.modulesState.stateMylist.paramCondition, 
                pageNum: pageNum, 
                pageSize: this.modulesState.stateMylist.pagination.pageSize 
            }); 
            if (!data.er && data.res) {   
                this.modulesState.stateMylist.pagination.total = data.res.pageMeta.total;
                this.modulesState.stateMylist.pagination.current = data.res.pageMeta.pageNum; 
                this.setModulesState(this.modulesState); 
                // 过滤重复的数据 
                // if (!this.modulesState.stateMylist.list[(pageNum-1) * this.modulesState.stateMylist.pagination.pageSize]) {
                //     this.modulesState.stateMylist.list = this.modulesState.stateMylist.list.concat(data.res.items && data.res.items.map((item, index) => {
                //         return {
                //             ...item,
                //             index:(pageNum-1) * this.modulesState.stateMylist.pagination.pageSize + index
                //         };
                //     }));
                //     this.modulesState.stateMylist.hasMoreItems = data.res.pageMeta.total > this.modulesState.stateMylist.list.length ;
                //     this.modulesState.stateMylist.pagination.total = data.res.pageMeta.total;
                //     this.modulesState.stateMylist.pagination.current = data.res.pageMeta.pageNum; 
                //     this.setModulesState(this.modulesState); 
                // } 
            }
        // }
    }
    /** 根据名称模糊查询公司 */
    public companyNameSearch = async (params) => {
        this.modulesState.companyVagueData = [] ;
        let data = await network.platformNetworkList(this, {  
            ...params,
            pageNum: 1, 
            pageSize: 100 
        }); 
        if (!data.er) {     
            this.modulesState.companyVagueData = data.res.items && data.res.items.map((item, index) => {
                return {
                    ...item,
                    value: item.companyId,
                    text: item.name
                };
            });
        } 
        this.setModulesState(this.modulesState);
        return data;
    }
    /** 平台网络，我的网络，查询详情 */
    public networkCompayDetail = async (companyId) => {
        const res = await network.networkCompanyDetail(this, {connectCompanyId: companyId});
        if (!res.er) {   
            this.modulesState.connectionState = 1; // 我的网络，都是取消
            this.modulesState.visibleWriteConnectionId = companyId;
            this.modulesState.remarkTemp = '';
            this.modulesState.companyCodeTemp = '';
            this.modulesState.visibleWrite = false;
            this.modulesState.visiblelabels = false;
            this.modulesState.companyCodeEdit = false;
            this.modulesState.statePlatform.detail = res.res;
            this.setModulesState(this.modulesState, () => this.elegantImagesGet(companyId));
        }
    }
    /** 平台网络，查看详情，需要根据状态判断是否是取消 */
    public networkCompayDetailNew = async (companyId, connectionState) => { 
        const res = await network.networkCompanyDetail(this, {connectCompanyId: companyId});
        if (!res.er) {   
            this.modulesState.connectionState = connectionState;
            this.modulesState.visibleWriteConnectionId = companyId;
            this.modulesState.remarkTemp = '';
            this.modulesState.visibleWrite = false;
            this.modulesState.visiblelabels = false;
            this.modulesState.statePlatform.detail = res.res;
            this.setModulesState();
        }
    }
    /** 更新上传状态 */
    /** 上传文件 */
    public sendUpload = async (values) => {
        // this.modulesState.sendupload = true;
        
        const resp = await network.inviteBatchNetworkCompany(this, {file: values}); 
        if (resp.er) {
            message.error('接口调用出错');
            return ;
        }

        if (resp.res.commit) {
            let result = resp.res.invitationResult;
            message.success(`批量邀请成功: 发送连接 ${result.connectionNum} 个, 发送邀请 ${result.invitedNum} 个。`);
        } else { 
            let failedResult = resp.res.invitationFailedResult || [];
            Modal.error({
                title: '批量邀请失败',
                content: failedResult.map((item, index)=>{
                    return <p key={index}>第 {item.invitationSeq} 条: {item.failedInfo}</p>;
                }),
            });
        }   
        this.pageListWaitingJoinListAll();
        // this.setModulesState()
    }
    /** 用户，查询公司详情 */  
    public userNetworkCompayDetail = async (companyId) => {
        const res = await network.userNetworkCompanyDetail(this, {connectCompanyId: companyId});
        if (!res.er) {   
            this.modulesState.visibleWriteConnectionId = companyId;
            this.modulesState.remarkTemp = '';
            this.modulesState.visibleWrite = false;
            this.modulesState.visiblelabels = false;
            this.modulesState.statePlatform.detail = res.res;
            this.setModulesState(this.modulesState, () => this.elegantImagesGet(companyId));
        }
        
    }

    // 获取公司风采图
    public elegantImagesGet = async (companyId) => {
        this.modulesState.imgList = [];
        this.setModulesState();
        const res: any = await companyInfo.elegantImagesGet(this,{
            companyId: companyId
        });
        if (res.er) {
            return;
        }
        this.modulesState.imgList = Array.isArray(res.res) ? res.res : [];
        this.setModulesState();
    }

    /** 待加入详情 */
    /** 平台网络，查询详情 */
    public networkWaitingCompayDetail = async (companyId, isShowRefuseId) => {
        const res = await network.networkCompanyDetail(this, {connectCompanyId: companyId});
        if (!res.er) {   
            this.modulesState.visibleWriteConnectionId = companyId;
            this.modulesState.remarkTemp = '';
            this.modulesState.visibleWrite = false;
            this.modulesState.visiblelabels = false;
            this.modulesState.statePlatform.detail = res.res;
            this.modulesState.isShowRefuseId = isShowRefuseId;
            this.setModulesState();
        }
    }
    /** 平台网络，查询详情 设置表单值 */
    public networkCompayDetailSetForm = async (companyId, form) => {
        const res = await network.networkCompanyDetail(this, {connectCompanyId: companyId});
        if (!res.er) {     
            this.modulesState.showLinkButtonDetail = res.res; 
            form.setFieldsValue({
                // invitationEmail: this.modulesState.showLinkButtonDetail.email, // 暂时屏蔽选择公司带出邮箱
                invitationCompanyName: this.modulesState.showLinkButtonDetail.name
            });
            this.setModulesState();
        }
    }

    public updateShowLinkButtonDetail = option => {
        this.modulesState.showLinkButtonDetail = option;
        this.setModulesState();
    }

    /** 清空数据（模糊查询出的公司详情） */
    public clearShowLinkButtonDetail = async () => {
        this.modulesState.showLinkButtonDetail = null;
        this.setModulesState();
    }
    /** 平台网络，发送连接请求 */
    public sendRelation = async (param) => {
        const res = await network.sendNetworkRequest(this, param);
        if (!res.er) {    
            if (res.res.success) {
                message.success('连接邀请已经发送');
                // this.hideAside(); 
                // 不关闭弹窗，继续邀请下一个
                this.modulesState.showLinkButtonDetail = null;
                this.modulesState.isShowRefuseId = '';
                this.setModulesState();
            } else {
                message.error(res.res.message);
            } 
        }
    }
    /** 我的网络，发送取消连接 */
    sendCancelRelation = async (param,callback?) => {
        const res = await network.cancelNetworkRelation(this, param);
        if (!res.er) {    
            if (res.res) {
                message.success('操作成功');
                // 刷新三个列表
                this.hideAside();
                await this.pageListMyList();
                await this.pageListPlatform(); 
                await this.pageListWaitingJoinList(); 
                // 刷新待加入列表数量
                await this.pageListWaitingJoinListAll();
                if(callback){callback();}
            } else {
                message.error('取消连接失败');
            } 
        }
    }
    /** 
     * 初始化翻页控件数据,我的网络
     */
    public initModulesStateMyList = () => {
        this.modulesState.stateMylist.pagination = {
            total: 0,
            current: 1,
            defaultCurrent: 1,
            pageSize: 20, 
            onChange: this.pageListMyList
        };
        this.setModulesState(this.modulesState);
    }
    /**
     * 网络管理，我的网络列表查询
     * @param pageNum 第几页 
     * @memberof ModulesAction
     */
    public pageListMyList = async (pageNum = 1) => { 
        this.modulesState.stateMylist.hasMoreItems = true;
        let data = await network.myNetworkList(this, { ////////
            ...this.modulesState.stateMylist.paramCondition, 
            pageNum: pageNum, 
            pageSize: this.modulesState.stateMylist.pagination.pageSize 
        }); 
        if (!data.er && data.res) {  
            this.modulesState.stateMylist.list = data.res && data.res.items && data.res.items.map((item:any, index) => {
                return {
                    ...item,
                    index,
                    labels: [...item.labels]
                };
            }); 
            this.modulesState.stateMylist.pagination.total = data.res.pageMeta.total;
            this.modulesState.stateMylist.pagination.current = data.res.pageMeta.pageNum;   
            this.setModulesState(this.modulesState);
        }
    }  
    /** 
     * 初始化翻页控件数据,待加入列表
     */
    public initModulesStateWaitingJoinList = () => {
        this.modulesState.stateWaitingjoin.pagination = {
            total: 0,
            current: 1,
            defaultCurrent: 1,  
            pageSize: 20, 
            onChange: () => console.log('1')
        };
        this.setModulesState(this.modulesState);
    }
    /**
     * 网络管理，待加入网络列表查询
     * @param pageNum 第几页 
     * @memberof ModulesAction
     */
    public pageListWaitingJoinList = async (pageNum = 1) => { 
        this.hideAside();
        // this.modulesState.stateWaitingjoin.hasMoreItems = true;
        let data = await network.networkWaitingJoinList(this, { 
            ...this.modulesState.stateWaitingjoin.paramCondition, 
            pageNum: pageNum, 
            pageSize: this.modulesState.stateWaitingjoin.pagination.pageSize 
        }); 
        if (!data.er) {  
            this.modulesState.stateWaitingjoin.list = [];
            this.modulesState.stateWaitingjoin.list = data.res.map((item, index) => {
                return {
                    ...item,
                    index
                };
            });
            // for (let i = 0; i <  data.res.length; i++) { 
            //     if (i <= this.modulesState.stateWaitingjoin.pagination.pageSize - 1) {
            //         this.modulesState.stateWaitingjoin.list.push({
            //             ...data.res[i],
            //             index: i
            //         });
            //     }
            // } 
            this.modulesState.stateWaitingjoin.pagination.total = data.res.length; 
            //  真实情况，此列表中只会存在 ，connectionState 为0和3的情况  
            // let totalAcceptOrRefuse = 0 ;
            // data.res.forEach((item, index) => {
            //     if (item.type === 1 && item.connectionState === 3) {
            //         // totalAcceptOrRefuse++;
            //     }
            // });
            this.modulesState.stateWaitingjoin.pagination.total = data.res.length; 
            // this.modulesState.stateWaitingjoin.totalAcceptOrRefuse = totalAcceptOrRefuse; 
            this.setModulesState(this.modulesState);
        }
    }
    /** 待加入列表，查出总条数，后端没接口，考虑到数量不大的情况，暂传入1000查 */
    public pageListWaitingJoinListAll = async (pageNum = 1) => { 
        let data = await network.networkWaitingJoinList(this, { 
            ...this.modulesState.stateWaitingjoin.paramCondition, 
            pageNum: 1, 
            pageSize: 10000 
        }); 
        if (!data.er) {   
            //  真实情况，此列表中只会存在 ，connectionState 为0和3的情况 
            // let totalAcceptOrRefuse = 0 ;
            // data.res.forEach((item, index) => {
            //     // if (item.type === 1 && item.connectionState === 3) { // 学通say暂时屏蔽
            //         totalAcceptOrRefuse++;
            //     // }
            // });
            this.modulesState.stateWaitingjoin.pagination.total = data.res.length; 
            this.modulesState.stateWaitingjoin.totalAcceptOrRefuse = data.res.length; //  totalAcceptOrRefuse;
            this.setModulesState(this.modulesState);
        }
    }

    /** 滚动分页： 待加入列表 */
    public pageListAdminWaitingJoinscroll = async () => {  
        if (this.modulesState.stateWaitingjoin.hasMoreItems) { 
            let pageNum = this.modulesState.stateWaitingjoin.pagination.current + 1;
            let data = await network.networkWaitingJoinList(this, { 
                ...this.modulesState.stateWaitingjoin.paramCondition, 
                pageNum: 1, 
                pageSize: pageNum * this.modulesState.stateWaitingjoin.pagination.pageSize, // this.modulesState.stateWaitingjoin.pagination.pageSize 
            }); 
            if (!data.er) {    
                this.modulesState.stateWaitingjoin.list = [];
                for (let i = 0; i <  data.res.length; i++) { 
                    if (i <= pageNum * this.modulesState.stateWaitingjoin.pagination.pageSize - 1) {
                        this.modulesState.stateWaitingjoin.list.push({
                            ...data.res[i],
                            index: i
                        });
                    }
                } 
                this.modulesState.stateWaitingjoin.hasMoreItems = this.modulesState.stateWaitingjoin.pagination.total > this.modulesState.stateWaitingjoin.list.length ;
                this.modulesState.stateWaitingjoin.pagination.current = Math.ceil(pageNum * this.modulesState.stateWaitingjoin.pagination.pageSize); 
                this.setModulesState(this.modulesState); 
            }
        }
    }
    /** 单个，邀请公司 */
    public invitOneCompany = async (params) => {
        let res = await network.inviteOneNetworkCompany(this, params);  
        if (!res.er) {    
            if (!res.res) {
                message.error('发送邀请失败'); 
            } else {
                message.success('成功发送邀请');
                // this.hideAside(); 
            }
        }
        this.pageListWaitingJoinListAll();
    }
    /** 取消邮件邀请 */
    public cancelInvite = async (params) => {
        let res = await network.cancelNetworkInvite(this, params);  
        if (!res.er) {    
            if (!res.res) {
                message.error('取消邮件邀请失败'); 
            } else {
                message.success('成功取消邮件邀请');
                this.pageListWaitingJoinList();
                // this.hideAside(); 
            }
        }
    }
    /** 批量邀请公司 */
    public inviteBatchCompany = async (params) => {
        let res = await network.inviteBatchNetworkCompany(this, params);  
        if (!res.er) {    
            console.log('上传结果L:', res.res);
        }
    }
    /** 接受网络连接邀请 */
    public acceptRelation = async (param) => {
        let res = await network.acceptNetworkRelation(this, param);  
        if (!res.er) {    
            if (!res.res) {
                message.error('发送邀请失败'); 
            } else {
                message.success('已建立连接'); 
                // 刷新待加入列表数量
                await this.pageListWaitingJoinListAll();
                await this.pageListWaitingJoinList(); 
            }
        }
    }
    /** 修改备注 */
    public changeRemarkWrite = async () => {
        this.modulesState.visibleWrite = true;
        this.setModulesState(); 
    }
    /** 修改公司的标签 */
    public changelabels = () => {
        this.modulesState.visiblelabels = true;
        this.setModulesState();
    }
    /** 取消修改备注 */
    public cancelchangeRemarkWrite = async () => {
        this.modulesState.visibleWrite = false;
        this.setModulesState(); 
    }
    /** 取消修改标签 */
    public cancelchangelabels = async () => {
        this.modulesState.visiblelabels = false;
        this.setModulesState(); 
    }
    /** 管理员更新备注 */
    /** type: 1->更新公司备注 2->更新公司代码 */
    public changeCompanyRemark = async (params, type?: number) => {
        let res = await network.updateRemark(this, params);
        if (!res.er) {    
            if (!res.res) {
                if (type === 0) {
                    message.error('更新公司备注失败'); 
                } else if (type === 1) {
                    message.error('更新公司代码失败'); 
                }
            } else {
                if (type === 0) {
                    message.success('更新公司备注成功'); 
                    this.modulesState.remarkTemp = params.remarkInfo;
                } else if (type === 1) {
                    message.success('更新公司代码成功');
                    this.modulesState.companyCodeTemp = params.companyCode;
                }
                // this.hideAside(); // 清空标志数据
                // this.modulesState.visibleWriteConnectionId = '';
                this.setModulesState();
                return res;
            }
        }
    }

    /** 用户更新备注 */
    public changeUserCompanyRemark = async (params) => {
        let res = await network.userUpdateCompanyRemark(this, params);
        if (!res.er) {    
            if (!res.res) {
                message.error('更新公司备注失败'); 
            } else {
                message.success('更新公司备注成功');
                // this.hideAside(); // 清空标志数据
                this.modulesState.visibleWrite = false;
                this.modulesState.remarkTemp = params.remarkInfo;
                // this.modulesState.visibleWriteConnectionId = '';
                this.setModulesState(); 
            }
        }
    }
    /** 网络用户，切换 展开合并 待加入列表 */
    public changeShowOrNo = async () => {
        this.modulesState.waitinglistshow = !this.modulesState.waitinglistshow ;
        this.setModulesState();
    }
    /**
     * 网络用户，网络列表查询
     * @param 
     * @memberof ModulesAction
     */
    public pageListUsersListAll = async (pramas) => { 
        let data = await network.userNetworkMyList(this, { 
            // ...this.modulesState.stateUserlist.paramCondition,  
            ...pramas,
            pageNum: 1, 
            pageSize: 1000 
        }); 
        if (!data.er) {      
            // let pageSortUserArray = this.pySegSort((data.res.concat(data.res).concat(data.res).concat(data.res).concat(data.res).concat(data.res).concat(data.res).concat(data.res))); 
            let pageSortUserArray = this.pySegSort(data.res); 
            this.modulesState.stateUserlist.list = data.res && data.res.map((item, index) => {
                return {
                    ...item,
                    index
                };
            });
            this.modulesState.stateUserlist.sortList = pageSortUserArray; 
            this.modulesState.stateUserlist.pagination.total = data.res.length;
            this.modulesState.stateUserlist.pagination.current = 1; 
            this.setModulesState(this.modulesState);
        }
    }
    public pageListUsersListTest = async (params: IRequestParams):Promise<any[]> => {  
        // let data = await network.userNetworkMyList(this, {  
        //     fuzzyConnectionName: params && params.name,
        //     pageNum: 1, 
        //     pageSize: 1000 
        // });    
        // return data.res; 
        return  [ 
            {
                "companyId": "bb15da22-b8g90-4ceb-b830-d42c3676a896",
                "connectionId": "f91820f4-b205-4954-a176-1bd173a920a2",
                "connectionName": "未来科技QKA"
            }
        ];
    }
    /** 判断是否为中文 */
    public isChinese(temp: string)  
    {  
        var re=/[^\u4e00-\u9fa5]/;  
        if(re.test(temp)) {
            return false;  
        } else {
            return true;  
        }
    } 
    /** 判断是否为英文 */
    public isEnglish(temp: string)  
    {  
        var re=/[a-zA-Z]/;  
        if(re.test(temp)) {
            return false;  
        } else {
            return true;  
        }
    }  
    /** 汉字首字母按照字母分类，排序 */
    public pySegSort(arr: any[]) { 
        if(!String.prototype.localeCompare){ 
            return null;
        }  
        var letters = '*abcdefghjklmnopqrstwxyz'.split('');
        var zh = '阿八嚓哒妸发旮哈讥咔垃痳拏噢妑七呥扨它穵夕丫帀'.split('');
         
        var segs = [];
        var curr;
        letters.forEach((item, i) => {
            curr = {letter: item, data:[]};
            arr.forEach((jtem, j) => {
                let name = jtem;
                if ( typeof(jtem) === 'object') {
                    name = jtem.name || jtem.connectionName || '无';
                }    
                if ( item.toUpperCase() === name.substr(0,1).toUpperCase())  { // 英文  
                    curr.data.push(jtem);
                } else if( this.isChinese(name.substr(0,1)) && ((!zh[i-1] || zh[i-1].localeCompare(name,'zh') <= 0) && name.localeCompare(zh[i],'zh') === -1)) { // 汉字
                    curr.data.push(jtem);
                } else if ((!isNaN(name.substr(0,1))) && item === '*') { // 数字放在*中
                    curr.data.push(jtem); 
                }

            }); 
            if(curr.data.length) {
                segs.push(curr);
                curr.data.sort(function(a: any,b: any){
                    let aname = a.name || a.connectionName || '无';
                    let bname = b.name || b.connectionName || '无'; 
                    return aname.localeCompare(bname, 'zh');
                });
            }
        });
        return segs;
    }
    /** 用户数据，待加入列表 */
    public pageListWaitingListAll = async (params) => { 
        let data = await network.networkWaitingJoinList(this, { 
            // city: '',
            // country: 'string',
            // name: 'string',
            // state: 'string',
            // taxId: 'string',
            ...params, 
            pageNum: 1, 
            pageSize: 1000 
        }); 
        if (!data.er) {  
            // let pageSortWaitingJoinArray = this.pySegSort(data.res);
            // this.modulesState.stateUserWaitingjoinlist = pageSortWaitingJoinArray;
            this.modulesState.stateUserWaitingjoinlist = data.res && data.res.map((item, index) => {
                return {
                    ...item,
                    index
                };
            }); 
            this.setModulesState();
        }
    }
    /** 获取国家列表 */
    public getCountry = async () => {
        const res = await createCompany.country(this, null);
        if (!res.er) {
            this.modulesState.countryList = res.res.countryList;
            this.setModulesState();
        }
    }
    /** 城市模糊查询 */
    public handleCityChange = async (keyworks) => {
        if (keyworks && keyworks.trim()) {  
            const res = await network.fuzzyQueryCity(this, {name: keyworks}); 
            if (!res.er) {
                this.modulesState.cityVagueData = res.res; 
            }
        } else {
            this.modulesState.cityVagueData = []; 
        }
        this.setModulesState();
    }
    /** 搜索条件 */ 
    public handleSearch = async (searchs) => {
        /** 判断我的网络，平台网络搜索条件 */ 
        this.modulesState.tabchange === '1' ? 
        this.modulesState.stateMylist.paramCondition = {
            city: searchs.city,
            connectionTaxId: searchs.connectionTaxId, 
            country: searchs.country,
            fuzzyConnectionName: searchs.connectionName,
            labelIds: searchs.labelIds,
        } :
        this.modulesState.statePlatform.paramCondition = {
            city: searchs.city,
            country: searchs.country,
            name: searchs.connectionName,  
            taxId: searchs.connectionTaxId,
        };
        this.setModulesState(); 
        this.modulesState.tabchange === '1' ?  this.pageListMyList(1) : this.pageListPlatform(1);
    }
    public hideAside = () => {
        this.modulesState.showLinkButtonDetail = null;
        this.modulesState.isShowRefuseId = ''; 
        this.modulesState.connectionState = 0;
        this.modulesState.visibleWrite = false;
        this.modulesState.visiblelabels = false;
        this.modulesState.visibleWriteConnectionId = '';
        this.modulesState.statePlatform.detail = {};
        this.modulesState.remarkTemp = '';
        this.setModulesState();
        MyStore.instance.dispatch(reducers.aside.ActionTypes.hide, null);
    }  

    public changeCompanyCodeEdit = (b) => {
        this.modulesState.companyCodeEdit = b;
        this.setModulesState();
    }
    /**
     * 公司风采弹框
     */
    public showEleganceModal = (isShow: boolean, src?: string) => {
        this.modulesState.showEleganceModal = isShow;
        this.modulesState.imgUrlElegance = src;
        this.setModulesState();
    } 
    /** 获取标签列表 */
    public getTagData = async () => {
        const res = await tagmodule.tagList(this, null); 
        this.modulesState.tagData = []; 
        if (!res.er) { 
            this.modulesState.tagData = res.res && res.res.map(item=>({
                title: item.labelName,
                value: item.labelId + '',
                key: item.labelId +'',
                label: '无标签'
            }));  
            this.setModulesState();
        }
    }
    /** 获取标签分类以及标签列表 */
    public getCategoryAndTagData = async () => {
        const res = await tagmodule.getAllTagAndCateList(this, null); 
        this.modulesState.tagData = []; 
        if (!res.er) { 
            this.modulesState.tagData = res.res && res.res.items && res.res.items.map(item=>({
                title: item.categoryName,
                value: item.categoryId + 'cate',
                key: item.categoryId +'cate', 
                disabled: true,
                selectable: false,
                children: item.labels && item.labels.map(tag => ({
                    title: tag.labelName,
                    value: tag.labelId +'',
                    key: tag.labelId + '',
                    isLeaf: true,
                }))
            }));  
            this.setModulesState();
        }
    }
    /** 公司关联标签 */
    setTagToCompany = async (rec) => {
        // companyApplyTag
        const res = await network.companyApplyTag(this, {
            companyId: rec.companyId,
            labelIds: rec.labelIds
        }); 
        if (!res.er) { 
            // 正确返回
            message.success('标签关联公司成功'); 
            // 更新详情
            await this.networkCompayDetail(rec.companyId);
            // 更新列表
            await this.pageListMyList(this.modulesState.stateMylist.pagination.current);
            this.modulesState.visiblelabels = false;
            this.setModulesState(); 
        } else {
            message.error('标签关联公司失败'); 
        }
    }
}

export default new ModulesAction();



// WEBPACK FOOTER //
// ./src/display/platform/Network/Modules.Action.tsx